import React, { useEffect, useRef, useState } from "react";
import { Icon } from "semantic-ui-react";
import { FormattedMessage, useIntl } from "react-intl";
import styles from "./OtherPatterns.module.scss";
import { Heading2 } from "../../../components/value-cssmodules/TextComponent";
import { useDispatch, useSelector } from "react-redux";
import { getPatternsByUserId } from "../../../actions/patternActions";
import isEmpty from "../../../validation/is-empty";
import PatternBox from "../../Patterns/PatternBox";
import { PatternData } from "../../../types/siteTypes";
import { patternSelector } from "../../../utils/selectors";

type OwnProps = {
  patternId: string;
};

const OtherPatterns: React.FC<OwnProps> = ({ patternId }) => {
  const dispatch = useDispatch();
  const { pattern } = useSelector((state: any) => patternSelector(state));
  const patterns = useSelector((state: any) => state.patternList.patterns);
  const intl = useIntl();
  const trackRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  useEffect(() => {
    if (pattern && pattern.user) {
      dispatch(getPatternsByUserId(pattern.user));
    }
  }, [dispatch, pattern]);

  // when list changes or component mounts update scroll button state
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const updateScrollState = () => {
      setCanScrollLeft(track.scrollLeft > 0);
      setCanScrollRight(track.scrollLeft + track.clientWidth < track.scrollWidth - 1);
    };
    updateScrollState();
    track.addEventListener("scroll", updateScrollState);
    window.addEventListener("resize", updateScrollState);
    return () => {
      track.removeEventListener("scroll", updateScrollState);
      window.removeEventListener("resize", updateScrollState);
    };
  }, [patterns]);

  const scroll = (dir: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    const slide = track.querySelector(`.${styles.slide}`) as HTMLElement | null;
    if (!slide) return;
    const gap = 16;
    const slideWidth = slide.offsetWidth + gap;
    track.scrollBy({ left: dir * slideWidth, behavior: "smooth" });
  };

  return !isEmpty(patterns) && Array.isArray(patterns) ? (
    <section className={styles.other}>
      <Heading2>
        <FormattedMessage
          id={"nav.otherpatternpage"}
          defaultMessage={"Other products of seller"}
        />
      </Heading2>

      <div className={styles.sliderWrapper}>
        <button
          className={`${styles.arrow} ${styles.arrowLeft}`}
          onClick={() => scroll(-1)}
          disabled={!canScrollLeft}
          aria-label={intl.formatMessage({ id: "site.previous", defaultMessage: "Previous" })}
        >
          <Icon name="chevron left" />
        </button>

        <div className={styles.track} ref={trackRef}>
          {patterns
            .filter((e: any) => e._id !== patternId)
            .map((pat: PatternData, i: number) => (
              <div
                className={styles.slide}
                key={`Other-Patterns${pat._id}`}
              >
                <PatternBox pattern={pat} />
              </div>
            ))}
        </div>

        <button
          className={`${styles.arrow} ${styles.arrowRight}`}
          onClick={() => scroll(1)}
          disabled={!canScrollRight}
          aria-label={intl.formatMessage({ id: "site.next", defaultMessage: "Next" })}
        >
          <Icon name="chevron right" />
        </button>
      </div>
    </section>
  ) : null;
};

export default OtherPatterns;
